import React from "react";
import { Button } from "../../shared/Button/Button";
import {
  MAX_DESKS_WAYFINDER,
  MAX_ROOMS_WAYFINDER,
} from "../../../lib/utils/constants";

interface Props {
  desksCounter: number;
  roomsCounter: number;
  clearWorkspaces: () => void;
  handleConfirm: () => void;
  children?: React.ReactNode;
  clearLabel?: string;
  confirmLabel?: string;
}

export const WayFinderWorkspaceFooterPicker = ({
  desksCounter,
  roomsCounter,
  clearWorkspaces,
  handleConfirm,
  children,
  clearLabel = "All Clear",
  confirmLabel = "Confirm",
}: Props) => {
  return (
    <div className="pt-1 WayFinderWorkspaceFooterPicker">
      {children ? (
        children
      ) : (
        <>
          <span className="pt-1 d-block text-center WayFinderFormWorkspaces__counter">
            {roomsCounter} of max {MAX_ROOMS_WAYFINDER} rooms selected
          </span>
          <span className="pb-3 d-block text-center WayFinderFormWorkspaces__counter">
            {desksCounter} of max {MAX_DESKS_WAYFINDER} desks selected
          </span>
        </>
      )}

      <div className="flex-a-center justify-content-between WayFinderWorkspaceFooterPicker__buttons">
        <Button
          title={clearLabel}
          size="small"
          color="outline-secondary"
          onClick={clearWorkspaces}
        />
        <Button
          title={confirmLabel}
          size="small"
          color="primary"
          onClick={handleConfirm}
        />
      </div>
    </div>
  );
};
